import { FaqItem } from './FaqItem';
/**
 * PopulateFaqProps
 * @memberof FaqComponent
 * @alias PopulateFaqProps
 * @typedef {object} PopulateFaqProps
 * @param {String} question
 * @param {String} answer
 * @param {String} id
 */
export type PopulateFaqProps = {
  question: string;
  answer: any;
  id: string;
};
/**
 * FaqDataProps
 * @memberof FaqComponent
 * @alias FaqDataProps
 * @typedef {Object} FaqDataProps
 * @param {Array} [PopulateFaqProps]
 */
export type FaqDataProps = {
  faqData: PopulateFaqProps[];
};
/**
 * Faqcomponent
 * @alias FaqComponent
 * @remarks  This component is used to render the FAQ can be used as generic across
 * @param {Object} FaqDataProps  input props
 * @returns {Component}  renders the FaqComponent
 */
export const Faqcomponent = (props: FaqDataProps) => {
  const { faqData } = props;
  return (
    <section className="home__faq with-padding">
      <div className="container">
        <h2 className="section__title-small text--black text--bold">
          Frequently Asked Questions
        </h2>
        {faqData?.map((faq: PopulateFaqProps) => {
          return (
            <FaqItem
              question={faq.question}
              answer={faq.answer}
              id={faq.id}
              key={faq.id}
            />
          );
        })}
      </div>
    </section>
  );
};
